import styled from 'styled-components';

export const NotDTCStepYesNoContetn = styled.div`
  margin-top: 24px;
  display: flex;
  button {
    width: 130px;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-color: rgba(100, 78, 2, 0.1);
    box-shadow: inset 0 0 0 1px rgb(100 78 2 / 60%);
    color: #644e02;
    padding: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;

    &:not(:first-child) {
      margin-left: 20px;
    }
    &:hover {
      background-color: rgba(100, 78, 2, 0.3);
    }
  }
`;
